import { render, staticRenderFns } from "./tempAdd.vue?vue&type=template&id=07b41604&scoped=true&"
import script from "./tempAdd.vue?vue&type=script&lang=js&"
export * from "./tempAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b41604",
  null
  
)

export default component.exports